var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"application-icon",attrs:{"size":"xs","title":_vm.title,"src":'/img/icons/' + _vm.svg + '.svg'}})
}
var staticRenderFns = []

export { render, staticRenderFns }